var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"banner_part"}},[_c('video',{attrs:{"playsinline":"","autoplay":"","muted":"","loop":"","id":"bannerVideo"},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("../assets/image/banner_video.mp4"),"type":"video/mp4"}}),_vm._v(" Your browser does not support HTML5 video. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }